export const meetupDate = '2026-05-07';
export const meetupStartTime = '13:00';
export const timeZone = 'CET';
export const formName = 'europe-digital-sovereignty-2026-zurich';
export const logoUrl = 'https://andersenlab.com/?utm_source=sovereignty_zurich&utm_medium=event';

export const initialCoordinates = {
  lat: 47.363451045341826,
  lng: 8.531660380533394,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'Europe: Digital Sovereignty or Dependence?',
  address: 'FIFA Museum\nSeestrasse 27, 8002 Zürich',
  link: 'https://maps.app.goo.gl/aPjeyopnpA4fpWw98',
};
